import { type StateCreator } from "zustand";
import type { UserData } from "@vTypes/user-type.ts";

/**
 * User Slice Type
 * - 로그인 사용자 정보와 인증 상태를 관리하는 Slice
 * - Zustand를 사용하여 상태 관리
 */

export interface AuthSlice {
  loginUser: UserData | null;
  isAuthenticated: boolean;
  setLoginUser: (user: UserData | null) => void;
  official_title_name: string | null;
  profileImageUrl: string | null;
  gender: string | null;
  setPersonnelBasicInfo: (
    profileImageUrl: string | null,
    gender: string | null
  ) => void;
  logout: () => void;
}

export const createAuthSlice: StateCreator<AuthSlice> = (set) => ({
  loginUser: null,
  isAuthenticated: false,
  official_title_name: null,
  profileImageUrl: null,
  gender: null,
  setLoginUser: (user: UserData | null) => {
    // PT 대비 나사렛국제병원 오피스 이름 설정
    // if (user?.account_id === "yss0401") {
    //   user.office_name = "나사렛국제병원";
    // }
    set({
      loginUser: user,
      isAuthenticated: !!user,
    });
  },
  setPersonnelBasicInfo: (
    profileImageUrl: string | null,
    gender: string | null
  ) =>
    set({
      profileImageUrl,
      gender,
    }),
  logout: () =>
    set({
      loginUser: null,
      isAuthenticated: false,
      profileImageUrl: null,
      gender: null,
    }),
});
